package de.xtl.retroguide

import web.storage.localStorage

actual fun defaultSessionAccessStorage() = SessionAccessStorage(
    readText = { localStorage.getItem("retro_session_access") },
    writeText = { value ->
        if (value == null) localStorage.removeItem("retro_session_access")
        else localStorage.setItem("retro_session_access", value)
    },
)
